import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

export const columnsComments: GridColDef[] = [
  {
    field: "date_time",
    headerName: "Fecha Alta",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div className="flexCenter">
        {dayjs(params.row.date_time).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    field: "type",
    headerName: "Tipo comentario",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div className="flexCenter">
        {params.row.internal ? "Interno" : "A informes"}
      </div>
    ),
  },
  {
    field: "analyst.email",
    headerName: "Analista",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <div className="flexCenter">{params.row.analyst.username}</div>
    ),
  },
  {
    field: "comment",
    headerName: "Comentario",
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
];
